import { Injectable } from "@angular/core";
import { Observable, of, observable } from "rxjs";
import { IProjectElementDetailsInput, IProjectElementDetailsOutput } from "../ViewModel/ProjectElementsModel";

export enum Module {
    UploadDocument = 1,
    ScheduleDocument = 2,
    Workflow = 3,
    Communication = 4,
    Transmittal = 5,
}

@Injectable({ providedIn: "root" })
export class ElementDetailsCacheService {
    private elementDetailCache: Map<string, Observable<any>> = new Map<string, Observable<any>>();
    mapElementDetails(key: string, result: IProjectElementDetailsOutput[]) {
        this.elementDetailCache.set(key, of(result));
    }

    hasElementDetails(key: string): boolean {
        return this.elementDetailCache.has(key)
    }

    getElementDetails(key: string): Observable<any> {
        let x= this.elementDetailCache.get(key);
        return x?x:new Observable<any>();
    }
    deleteElementDetails(key: string) {
        if (this.elementDetailCache.has(key)) {
            this.elementDetailCache.delete(key);
        }
    }
    clearElementDetailCache() {
        this.elementDetailCache.clear();
    }

}